export function defaultInitCode() {
  // footer year
  const yearElement = document.querySelector('.year');
  if(yearElement) {
    yearElement.innerText = `${new Date().getFullYear()}`;
  }

  // copyright
  if (navigator.userAgent.indexOf("Chrome") != -1 || navigator.userAgent.indexOf("Firefox") != -1 ) {
    var e = ["%c Created by SWIM team at Swim.ai Inc. %c @Swim.ai %c www.swim.ai", "display:block; padding:5px; background: #4171B8; color:#fff;", "display:block; padding:5px; background: #6ccbf4; color:#fff;", "display:block; padding:5px;"];
    console.info.apply(console, e);
  }
}

export function requestInterval(fn, delay) {
  var requestAnimFrame = (function () {
    return window.requestAnimationFrame || function (callback, element) {
      window.setTimeout(callback, 1000 / 60);
    };
  })(),
  start = new Date().getTime(),
  handle = {};
  function loop() {
    handle.value = requestAnimFrame(loop);
    var current = new Date().getTime(),
    delta = current - start;
    if (delta >= delay) {
      fn.call();
      start = new Date().getTime();
    }
  }
  handle.value = requestAnimFrame(loop);
  return handle;
};

// Work around webpack resize onload
export function webpackWorkAround() {
  let resizeCounter = 0;
  const resizeTimer = setInterval(()=> {
    if(resizeCounter >= 1) { clearInterval(resizeTimer); }
    // For a full list of event types: https://developer.mozilla.org/en-US/docs/Web/API/document.createEvent
    var el = document; // This can be your element on which to trigger the event
    var event = document.createEvent('HTMLEvents');
    event.initEvent('resize', true, false);
    el.dispatchEvent(event);
    resizeCounter++;
  }, 1000);
}
